export class Recensione {
    c_cognome: string;
    c_nome: string;
    datarisposta: string;
    datarecensione: string;
    denominazione: string;
    extra: any;
    idCantina: number;
    idCliente: number;
    idRecensione: number;
    idRegione: number;
    modrewrite: string;
    mostraContenuto: boolean;
    mostraRisposta: boolean;
    regione: string;
    risposta: {
        datarisposta: string
        idoperatore: number
        idrisposta: number
        o_cognome: string
        o_nome: string
        risposta: string
        role: string
    };
    testo: string;
    titolo: string;
    tv_nome: string;
    valutazione: number;
    imgcantina: string;
    fake: boolean;
    mobileView: boolean;

    constructor(recensione) {
        this.c_cognome = recensione.c_cognome;
        this.c_nome = recensione.c_nome;
        this.datarisposta = recensione.datarisposta;
        this.datarecensione = recensione.datarecensione;
        this.denominazione = recensione.denominazione;
        this.extra = recensione.extra;
        this.idCantina = parseInt(recensione.idCantina, 10);
        this.idCliente = parseInt(recensione.idCliente, 10);
        this.idRecensione = parseInt(recensione.idRecensione, 10);
        this.idRegione = parseInt(recensione.idRegione, 10);
        this.modrewrite = recensione.modrewrite;
        this.mostraContenuto = false;
        this.mostraRisposta = false;
        this.regione = recensione.regione;
        this.risposta = recensione.risposta ? recensione.risposta : null;
        if (recensione.risposta != null) {
            this.risposta.datarisposta = recensione.risposta ? recensione.risposta.datarisposta : null;
            this.risposta.idoperatore = recensione.risposta ? parseInt(recensione.risposta.idoperatore, 10) : null;
            this.risposta.idrisposta = recensione.risposta ? parseInt(recensione.risposta.idrisposta, 10) : null;
            this.risposta.o_cognome = recensione.risposta ? recensione.risposta.o_cognome : null;
            this.risposta.o_nome = recensione.risposta ? recensione.risposta.o_nome : null;
            this.risposta.risposta = recensione.risposta ? recensione.risposta.risposta : null;
            this.risposta.role = recensione.risposta ? recensione.risposta.role : null;
        }
        this.regione = recensione.regione;
        this.testo = recensione.testo;
        this.titolo = recensione.titolo;
        this.valutazione = recensione.valutazione ? parseFloat(recensione.valutazione) : 0;
        this.imgcantina = recensione.imgcantina
        this.fake = recensione.fake
        this.mobileView = recensione.mobileView;
        this.tv_nome = recensione.tv_nome;
    }

    mostraDisponibile() {
        const minLength = this.mobileView ? 108 : 200;
        if (this.testo) {
            if (this.testo.replace(/[^\w\s]/g, "").length >= minLength) {
                return true;
            } else {
                return false;
            }
        }

    }

    showRisposta() {
        if (this.mostraRisposta) {
            this.mostraRisposta = false;
        } else {
            this.mostraRisposta = true;
        }
    }

    showContenuto() {
        console.log("click")
        if (this.mostraContenuto) {
            this.mostraContenuto = false;
        } else {
            this.mostraContenuto = true;
        }
    }
}